import { FeatureFlagFallbackProvider, createFeatureFlagProvider } from '@vizit/feature-flags';
import type { ComponentType, ReactNode } from 'react';

/**
 * Initialize feature flag provider based on environment configuration
 * Returns either LaunchDarkly provider or fallback provider
 */
export function initializeFeatureFlags(): ComponentType<{ children: ReactNode }> {
  const clientSideId = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID;

  // If no client ID, use fallback provider with defaults
  if (!clientSideId) {
    console.warn('LaunchDarkly not configured - using default flag values');
    return FeatureFlagFallbackProvider;
  }

  // Get user context from localStorage (set during auth)
  const userId = localStorage.getItem('user_id');
  const userEmail = localStorage.getItem('user_email');
  const organizationId = localStorage.getItem('organization_id');
  // Transitional: auth persists the default portfolio id, which doubles as the default workspace
  // scope pre-BLU-176. Swap the storage key once the workspace id is persisted directly at login.
  const workspaceId = localStorage.getItem('default_portfolio_id');

  try {
    return createFeatureFlagProvider({
      clientSideId,
      user: {
        key: userId || 'anonymous',
        email: userEmail || undefined,
        organizationId: organizationId || undefined,
        workspaceId: workspaceId || undefined,
      },
    });
  } catch (error) {
    console.error('Failed to initialize LaunchDarkly:', error);
    return FeatureFlagFallbackProvider;
  }
}
